
import { defineComponent, PropType } from 'vue'
import { iCategory } from './CategoriesManagement'
import { createValidations } from '../../../helpers/commons/validationHelper'
import { AxiosResponse } from 'axios'
import Dialog from 'primevue/dialog'
import descriptor from './CategoriesManagementDescriptor.json'
import validationDescriptor from './CategoriesManagementValidationDescriptor.json'
import KnValidationMessages from '../../../components/UI/KnValidatonMessages.vue'
import useValidate from '@vuelidate/core'
import Dropdown from 'primevue/dropdown'
export default defineComponent({
    name: 'category-management-dialog',
    components: { Dialog, Dropdown, KnValidationMessages },
    props: {
        propCategory: {
            type: Object as PropType<iCategory> | any,
            required: true
        }
    },
    emits: ['close', 'created'],
    setup() {},
    data() {
        return {
            descriptor: descriptor,
            validationDescriptor,
            category: {} as iCategory,
            dirty: false,
            v$: useValidate() as any,
            operation: 'insert',
            loading: false,
            categoryTags: [] as any
        }
    },
    validations() {
        return {
            category: createValidations('category', validationDescriptor.validations.category)
        }
    },
    computed: {
        formHeader(): any {
            return this.propCategory?.id ? this.$t('common.edit') : this.$t('common.new')
        },
        inputDisabled(): any {
            return this.propCategory
        },
        buttonDisabled(): any {
            return this.v$.$invalid
        }
    },
    watch: {
        propCategory() {
            this.category = { ...this.propCategory } as iCategory
        }
    },
    created() {
        if (this.propCategory?.id) this.loadCategoryData()
    },
    mounted() {
        if (this.propCategory) {
            this.category = { ...this.propCategory } as iCategory
        }
    },
    methods: {
        async loadCategoryData() {
            this.loading = true
            const url = this.getCategoryTagsUrl() as string
            await this.$http
                .get(url)
                .then((response: AxiosResponse<any>) => (this.categoryTags = response.data))
                .finally(() => (this.loading = false))
        },
        getCategoryTagsUrl() {
            switch (this.propCategory.type) {
                case 'DATASET_CATEGORY':
                    return process.env.VUE_APP_RESTFUL_SERVICES_PATH + `3.0/category/dataset/${this.propCategory.id}`
                case 'BM_CATEGORY':
                    return process.env.VUE_APP_RESTFUL_SERVICES_PATH + `3.0/category/metamodel/${this.propCategory.id}`
                case 'GEO_CATEGORY':
                    return process.env.VUE_APP_RESTFUL_SERVICES_PATH + `3.0/category/geolayer/${this.propCategory.id}`
                case 'KPI_KPI_CATEGORY':
                    return process.env.VUE_APP_RESTFUL_SERVICES_PATH + `3.0/category/kpi/${this.propCategory.id}`
                case 'KPI_TARGET_CATEGORY':
                    return process.env.VUE_APP_RESTFUL_SERVICES_PATH + `3.0/category/kpitarget/${this.propCategory.id}`
                case 'KPI_MEASURE_CATEGORY':
                    return process.env.VUE_APP_RESTFUL_SERVICES_PATH + `3.0/category/kpiruleoutput/${this.propCategory.id}`
            }
        },
        async handleSubmit() {
            if (this.v$.$invalid) return
            if (this.category.id) this.operation = 'update'
            await this.sendRequest().then(() => {
                this.$store.commit('setInfo', {
                    title: this.$t(this.descriptor.operation[this.operation].toastTitle),
                    msg: this.$t(this.descriptor.operation.success)
                })
                this.$emit('created')
            })
        },
        sendRequest() {
            if (this.operation === 'insert') return this.$http.post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '3.0/category', this.category)
            else {
                delete this.category.occurrences
                return this.$http.post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '3.0/category/update', this.category)
            }
        },
        closeTemplate() {
            this.$emit('close')
        }
    }
})
